<template>
  <b-modal
    title="Product Sorting"
    id="upsell-products-sort-modal"
    okTitle="Confirm"
    @ok="saveOrder"
    @show="onOpen"
    :ok-disabled="loading"
  >
    <p>
      Drag and drop to change the display order on the products upsell section
    </p>
    <draggable
      v-model="productsList"
      group="people"
      @start="drag = true"
      @end="drag = false"
    >
      <b-list-group-item v-for="element in productsList" :key="element._id">
        {{ element.name }}
      </b-list-group-item>
    </draggable>
  </b-modal>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "upsell-products-sort-modal",
  components: {
    draggable,
  },
  data: () => ({
    drag: false,
    productsList: [],
    loading: false,
  }),
  props: ["products"],
  methods: {
    saveOrder() {
      this.$emit("done", this.productsList);
    },
    onOpen() {
      this.productsList = this.products;
    },
  },
};
</script>

<style scoped></style>
